var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFigurestrengthtrainingfunctional(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 20.5828 25.5352",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 25.5352,
    opacity: 0,
    width: 20.5828,
    x: 0,
    y: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.84804 23.6367C8.30507 23.5078 8.58632 23.3672 8.77382 23.0156L11.3519 18.375C11.3988 18.293 11.434 18.2578 11.5394 18.2578L17.8441 18.2578L17.8441 24.1992C17.8441 24.8789 18.3832 25.3945 19.0277 25.3945C19.7074 25.3945 20.2348 24.8789 20.2348 24.1992L20.2348 17.2031C20.2348 16.418 19.8129 15.9492 18.9926 15.8789L13.684 15.3984L13.684 8.73047C13.684 7.42969 12.7699 6.35156 11.1644 6.35156L10.6019 6.35156C9.65272 6.35156 8.92616 6.51562 7.98866 7.21875L4.05116 10.1719C3.37147 10.6641 3.41835 11.6602 4.10975 12.1172L8.92616 15.3164L8.92616 15.6211L6.8285 21.4336L0.87538 23.0742C0.242567 23.25-0.132433 23.8945 0.0433487 24.5273C0.230849 25.1953 0.828505 25.5352 1.50819 25.3594ZM6.8285 11.0625L8.60975 9.72656C8.75038 9.63281 8.92616 9.70312 8.92616 9.87891L8.92616 12.457ZM11.1644 5.12109C12.559 5.12109 13.7074 3.97266 13.7074 2.54297C13.7074 1.14844 12.559 0 11.1644 0C9.73475 0 8.58632 1.14844 8.58632 2.54297C8.58632 3.97266 9.73475 5.12109 11.1644 5.12109Z",
    fill: "currentColor",
    fillOpacity: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigurestrengthtrainingfunctional);
export default __webpack_public_path__ + "static/media/figure.strengthtraining.functional.43d2405f38cb2ebc3a14133bde927744.svg";
export { ForwardRef as ReactComponent };